<header>
  <div class="container header--container">
    <div class="row">
      <div class="col aaos--row">
        <div class="navbutton-placeholder"></div>
        <a class="logo aaos-logo" href="/">
          <img src="https://aaoscdndev01-a0g7frdabzbncha7.a03.azurefd.net/aaosepi-globalnav/images/aaos-logo.svg" />
        </a>
      </div>
      <div class="aaos--row"> 
        <aaos-institution-title></aaos-institution-title>
      </div>
      <div class="col">
        <div class="aaos--row aaos--flex-end">

          <div class="navigation--account">
            <div class="aaos--links desktop--links">
              <ul>
                <li>
                  <a href="https://www.aaos.org/about/bylaws-policies/organizational-policies/website-disclaimer/terms-of-use/" target="_top">Terms of Use</a>
                </li>
                <li>
                  <a (click)="logout()" class="btn btn--outline btn--small" *ngIf="isLoggedIn" style="padding-right: 15px !important">LOGOUT</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>